<template>
  <section class="mt-4" v-if="withdrawals.length > 0">
        <h3 class="mx-4 p-4 text-lg font-bold">Withdrawal History</h3>
        <p class="m-4 p-4" v-if="withdrawals.length === 0">No withdrawals made yet.</p>
        <table class="w-full table-fixed" v-else>
            <thead>
                <tr class="border border-gray-light bg-gray-light">
                    <th class="w-3/12 uppercase text-xs text-left px-8 py-3">Date</th>
                    <th class="w-6/12 hidden md:inline-block uppercase text-xs text-left px-4 py-3">Description</th>
                    <th class="w-2/12 uppercase text-xs text-right px-4 py-3">Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr class="border border-bottom border-gray-light" v-for="(withdrawal, index) in withdrawals" :key="index">
                    <td class="px-8 py-2">{{ withdrawal.date }}</td>
                    <td class="hidden md:table-cell px-4 py-2">{{ withdrawal.description }}</td>
                    <td class="px-4 py-2 text-right">${{ withdrawal.amount }}</td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
export default {
    data() {
        return {
            withdrawals: [],
        }
    },
    mounted() {
        this.getWithdrawalHistory();
    },
    methods: {
        getWithdrawalHistory() {
            axios.get('/api/ambassador/withdrawals')
                .then(response => {
                    this.withdrawals = response.data.data;
                })
                .catch(console.error);
        }
    }
}
</script>

<style>

</style>